import { CATALOG_PAGE_ENDPOINTS } from "../constants";
export var getBaseUrl = function getBaseUrl() {
  if (process.env.NODE_ENV === 'development') {
    return CATALOG_PAGE_ENDPOINTS.getTariffsByColor;
  }
  if (typeof window !== 'undefined') {
    return "".concat(window.location.pathname, "getTariffsByColor/");
  }
  return '';
};